import { getConfig } from '../../../url-reader';
import TintService from '../../../shared/services/tint.service';

export class TintWrapper {
  private static tint: TintService;

  public static getTint(): TintService {
    return this.tint;
  }

  public static setTint(): void {
    const config = getConfig();
    this.tint = new TintService(config.tintSlug, {
      personalizationId: config.personalizationId,
      network: config.network,
      defaultQueryCount: config.count,
      defaultQuery: config.query,
      tags: config.tags,
      saved_filter_id: config.saved_filter_id || config['saved-filter-id'],
      product_sku: config.product_sku,
      from: config.from,
    });
  }
}
